<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      @selectField="onSelectField"
    />

    <!-- 사업개요 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업개요</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장주소(소재지)</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.address }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.fieldInfo.address"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.ceo }}</p>
          <ml-input
            v-else
            v-model="form.fieldInfo.ceo"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업(공사)금액</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.deposit_amount }}
          </p>
          <comma-input
            :readonly="true"
            v-else
            v-model="form.fieldInfo.deposit_amount"
            class="w-full flex-1"
          ></comma-input>
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">착공일</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.start_work_at }}
          </p>
          <date-selector
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.fieldInfo.start_work_at"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">준공일</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.be_completed_at }}
          </p>
          <date-selector
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.fieldInfo.be_completed_at"
          />
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">발주자</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.orderer }}</p>
          <ml-input
            v-else
            v-model="form.fieldInfo.orderer"
            class="w-full flex-1"
          />
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">누계 공정율</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.percent }}</p>
          <ml-input
            v-else
            v-model="form.fieldInfo.percent"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 환경보전비 -->
    <div class="print-container">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 환경보전비</h5>
        </vs-col>
      </vs-row>

      <table-budget
        v-model="form.budget"
        :usePrint="isPostId"
        :isPrint="isPrint"
        @budgetTotal="(data) => (form.budgetTotal = data)"
      />
    </div>
<div>{{form.budgetTotal}}</div>
    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
      title="환경보전비 사용내역 첨부(스캔)" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import TableBudget from "@/components/table-budget/TableBudget.vue";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    DateSelector,
    FileUploadModule,
    PhotoUploadGridModule,
    TableBudget,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.approval.list))];
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    header: {
      deep: true,
      handler(value) {
        console.log("header", value);
        this.oldDataSetting();
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fieldInfo: {
          address: "",
          ceo: "",
          deposit_amount: "",
          start_work_at: "",
          be_completed_at: "",
          orderer: "",
          percent: "",
        },
        budget: [
          {
            label: "1. 환경오염방지시설 설치 및 운영 비용",
            type: "env1",
            select1: ["대기", "수질", "소음진동", "토양", "기타"],
            select2: {
              대기: [
                "대기배출시설 설치 및 운영비용",
                "생활악취제거시설 설치 및 운영비용",
                "방진막(H=1.8m), 분진망(5층이상건물) 설치 및 운영비용",
                "방진망, 방진덮개 설치 및 운영비용 ",
                "부직포 설치 및 운영 비용",
                "(자동)세륜시설 설치 및 운영비용 ",
                "수조식 세륜시설 설치 및 운영비용 ",
                "이동식 살수차 운영비용 ",
                "고압살수기 설치 및 운영비용",
                "레미콘생산시설(BP) 집진시설 설치 및 운영비용",
              ],
              수질: [
                "폐수배출시설의 설치 및 운영비용(터널침출수,BP 포함)",
                "오수처리시설의 설치 및 운영비용",
                "단독정화조 설치 및 운영비용",
                "이동식화장실 설치 및 운영비용",
                "시험실 콘크리트양생수조 중화시설설치 비용",
              ],
              소음진동: [
                "소음진동 방지시설 설치 및 운영비용",
                "방음벽 설치 및 운영비용",
                "소음기, 흡음시설 설치 및 비용",
              ],
              토양: [
                "침사지, 오탁방지망 등 토양오염 방지시설 설치 및 운영비용 ",
                "오염토양처리 설치 및 운영비용",
              ],
              기타: [
                "야생수목 이식 비용",
                "자생식생복원 비용 ",
                "비탈면녹화 비용 ",
                "동물 이동통로 설치비용 ",
                "기타 환경오염방지시설의 설치 및 운영비용",
              ],
            },
            arcc: false,
            budget: 0,
            percent: 0,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "2. 폐기물의 처리 및 재활용 비용",
            type: "env2",
            select: [
              "순환골재 구입비용",
              "건설(현장)폐기물 위탁 처리비용(수집)",
              "건설(현장)폐기물처리업체 위탁 처리비용(운반,처리) ",
              "지정폐기물처리업체 위탁처리비용(수집,운반,처리) ",
              "재활용 폐기물 위탁처리비용(수집,운반,처리) ",
              "건설폐기물처리시설 설치 및 운영비용(재활용) ",
              "폐기물처리시설 설치 및 운영비용 ",
              "쓰레기슈트 설치 및 운영비용 ",
              "건설(현장)폐기물 임시보관장소 설치비용 ",
              "폐기물 분리수거함(가연성/불연성/재활용 등) 설치 및 운영비용 ",
              "지정폐기물(폐유보관함등) 및 위험물보관소 설치 및 운영비용",
              "(이동식)파쇄기 투입구 및 배출구에 살수시설 설치 및 운영비용",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "3. 환경계측 비용",
            type: "env2",
            select: [
              "현장내 대기,수질,소음․진동에 관한 측정비용(위탁,자가)",
              "환경기술개발및지원에관한법률에 의한 위탁측정비용",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "4. 환경교육훈련 비용",
            type: "env2",
            select: [
              "전문교육(현장 환경관리인을 대상으로 외부기관교육)비용",
              "정기교육(현장임직원을 대상)비용",
              "환경기술개수시교육(신입직원 및 일용직 직원 대상)비용",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "5. 현장 환경정리 비용",
            type: "env2",
            select: [
              "현장 환경훼손에 따른 정비․복원비용",
              "현장 정리정돈 청소도구 구입비용",
              "소음귀마개, 방진마스크 등 작업환경관리 물품 구입비용",
              "현장내 방역소독비용",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "6. 환경자료및 홍보물 구입 비용",
            type: "env2",
            select: [
              "현장내 환경법규 구입비용",
              "현장내 각종환경안내게시판, 환경프랑카드 등 설치비용",
              "기타 환경관련 자료구입비용(비디오테잎 등)",
              "현장내 환경관련 각종자료 발간비용",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "7. 환경기술인및 환경관련 인건비용",
            type: "env2",
            select: [
              "법정 환경기술인(대기,수질,소음․진동) 선임 인건비용",
              "화약류제조(관리)보안책임자 선임 인건비용",
              "세륜시설 운영시 관리인 인건비용",
              "소각로 운영시 관리인 인건비용",
              "이동식 살수차 운영시 인건비용",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "8. 기타",
            type: "env2",
            select: [
              "환경처리 약품 구입비용(세륜오탁수응집제, 중화제 등)",
              "환경운영관리 상태 모니터링 비용",
              "환경관련 각종세금(오폐수처리원인자부담금 등)",
              "기타",
            ],
            arcc: false,
            detail: {
              prevMonth: 0,
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
        ],
        budgetTotal: {},
        photoList: [],
        fileList: [],
      },
    };
  },
  mounted() {
    this.loadListApproval();
  },
  methods: {
    async loadListApproval() {
      // 내용불러오기
      const projectId = this.projectId;
      const boardSlug = "board-252";
      const page = 1;
      const perPage = 10000;
      const dateTarget = ["created_at"];
      const dateBegin = [`${new Date().getFullYear()}-01-01`];
      const dateEnd = [`${new Date().getFullYear()}-12-31`];

      await this.$store.dispatch("approval/LOAD_POST_ALL", {
        boardSlug,
        projectId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd,
      });

      this.oldDataSetting();
    },

    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.header;
      }
    },

    onSelectField(data) {
      this.form.fieldInfo.address = data.address;
      this.form.fieldInfo.deposit_amount = data.deposit_amount;
      this.form.fieldInfo.start_work_at = data.start_work_at;
      this.form.fieldInfo.be_completed_at = data.be_completed_at;
      this.form.fieldInfo.be_completed_at = data.be_completed_at;
    },

    oldDataSetting() {
      if (this.postList.length > 0) {
        const checkMonth = this.header.month;
        const budget = [];

        // 초기화
        for (let i = 0; i < this.form.budget.length; i++) {
          this.form.budget[i].detail.prevMonth = 0;
        }

        for (const post of this.postList) {
          if (post.document_status.code === "approved") {
            const head = this.getHeader(post);
            const content = this.getContent(post);

            // 전월 데이터
            if (
              moment(head.full).format("YYYY-MM") ===
              moment(this.header.full).subtract(1, "months").format("YYYY-MM")
            ) {
              for (let i = 0; i < content.budget.length; i++) {
                this.form.budget[i].detail.prevMonth =
                  content.budget[i].detail.now;
              }
            }

            // 이번달 이전의 데이터 찾기
            if (Number(head.month) < Number(checkMonth)) {
              if (content.budget && content.budget.length > 0) {
                for (let i = 0; i < content.budget.length; i++) {
                  const iBudget = content.budget[i];
                  if (!(budget[i] && budget[i].detail)) {
                    budget[i] = {
                      detail: {
                        now: iBudget.detail.now,
                      },
                    };
                  } else {
                    budget[i].detail.now += iBudget.detail.now;
                  }
                }
              }
            }
          }
        }

        if (budget.length > 0) {
          for (let i = 0; i < budget.length; i++) {
            this.form.budget[i].detail.prev = budget[i].detail.now;
          }
        } else {
          // 데이터가 없을 경우 누적 사용량 0원 처리
          for (const data of this.form.budget) {
            data.detail.prev = 0;
          }
        }
      } else {
        // 데이터가 없을 경우 누적 사용량 0원 처리
        for (const data of this.form.budget) {
          data.detail.prev = 0;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
